// Convierte fecha de YYYY-MM-DD o ISO (con T) a DD-MM-YYYY (solo para mostrar, no afecta sort/save)
export const formatDate = (date) => {
  if (!date) return "";
  const datePart = date.split("T")[0];
  const parts = datePart.split("-");
  if (parts.length !== 3) return date;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};
